"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/popover/style/css");

var _popover = _interopRequireDefault(require("antd/es/popover"));

require("antd/es/table/style/css");

var _table = _interopRequireDefault(require("antd/es/table"));

require("antd/es/card/style/css");

var _card = _interopRequireDefault(require("antd/es/card"));

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _lodash = require("lodash");

var _Column = _interopRequireDefault(require("antd/es/table/Column"));

var _moment = _interopRequireDefault(require("moment"));

var _reselect = require("reselect");

var _reactRouter = require("react-router");

var _badges = require("../../redux/badges/badges.types");

var selectors = _interopRequireWildcard(require("../../redux/selectors"));

var _Util = require("../util/Util");

var _AddBadgeCollectionModal = _interopRequireDefault(require("./AddBadgeCollectionModal"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const rowClassName = (record, index) => {
  return index % 2 === 0 ? 'tr-even-color' : 'tr-odd-color';
};

const initialState = {};

class BadgeCollections extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = initialState;

    this.showAddBadgeCollectionModal = () => {
      const {
        history,
        studyId
      } = this.props;
      history.push(`/study/${studyId}/badges/badgeCollections/new/`);
    };

    this.hideAddBadgeCollectionModal = () => {
      const {
        history,
        studyId
      } = this.props;
      history.push(`/study/${studyId}/badges/badgeCollection/`);
    };

    this.editBadgeCollection = badgeCollectionId => {
      const {
        history,
        studyId
      } = this.props;
      history.push(`/study/${studyId}/badges/badgeCollections/edit/${badgeCollectionId}`);
    };

    this.getDeleteIcon = badge => {
      if (badge.deleteDate) {
        return /*#__PURE__*/_react.default.createElement(_button.default, {
          onClick: () => this.undeleteBadgeCollection(badge.id)
        }, /*#__PURE__*/_react.default.createElement("i", {
          className: "fal fa-trash-undo-alt fa-lg"
        }));
      }

      return /*#__PURE__*/_react.default.createElement(_button.default, {
        onClick: () => this.deleteBadgeCollection(badge.id)
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "fal fa-trash-alt fa-lg"
      }));
    };

    this.renderActions = badgeCollection => {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "badge-action-container"
      }, /*#__PURE__*/_react.default.createElement("a", {
        title: "Edit",
        className: "badge-action",
        onClick: e => {
          e.stopPropagation();
          this.editBadgeCollection(badgeCollection.id);
        }
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "far fa-eye fa-lg"
      })), badgeCollection.deleteDate ? /*#__PURE__*/_react.default.createElement("a", {
        title: "Undelete",
        className: "badge-action",
        onClick: e => {
          e.stopPropagation();
          this.props.undeleteBadgeCollection(badgeCollection.id);
        }
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "fal fa-trash-undo-alt fa-lg"
      })) : /*#__PURE__*/_react.default.createElement("a", {
        title: "Delete",
        className: "badge-action",
        onClick: e => {
          e.stopPropagation();
          this.deleteBadgeCollection(badgeCollection.id);
        }
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "fal fa-trash-alt fa-lg"
      })));
    };

    this.onRow = row => {
      const {
        history,
        studyId
      } = this.props;
      return {
        onClick: event => {
          event.stopPropagation();
          history.push(`/study/${studyId}/badges/badgeCollections/edit/${row.id}`);
        }
      };
    };
  }

  async componentDidMount() {
    this.props.getBadgeCollections();
  }

  deleteBadgeCollection(badgeCollectionId) {
    this.props.deleteBadgeCollection(badgeCollectionId);
  }

  undeleteBadgeCollection(badgeCollectionId) {
    this.props.undeleteBadgeCollection(badgeCollectionId);
  }

  render() {
    const {
      badgeCollections,
      newOrEdit,
      requestedBadgeTab,
      id
    } = this.props;
    const {} = this.state;
    const showModal = !!(newOrEdit && requestedBadgeTab === 'badgeCollections');
    return /*#__PURE__*/_react.default.createElement(_card.default, {
      title: /*#__PURE__*/_react.default.createElement("div", {
        className: "badges-title"
      }, /*#__PURE__*/_react.default.createElement("h1", null, "Badge Collections"), /*#__PURE__*/_react.default.createElement(_button.default, {
        type: "primary",
        onClick: this.showAddBadgeCollectionModal
      }, " + Add Badge Collection"))
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_AddBadgeCollectionModal.default, {
      visible: showModal,
      hide: this.hideAddBadgeCollectionModal
    }), /*#__PURE__*/_react.default.createElement(_table.default, {
      dataSource: badgeCollections,
      pagination: {
        pageSize: 100
      },
      rowClassName: rowClassName,
      onRow: this.onRow,
      rowKey: "id"
    }, /*#__PURE__*/_react.default.createElement(_Column.default, {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: "70px",
      defaultSortOrder: "ascend",
      sorter: (a, b) => a.id - b.id
    }), /*#__PURE__*/_react.default.createElement(_Column.default, {
      title: "Label",
      dataIndex: "label",
      key: "label",
      width: "200px",
      sorter: (a, b) => `${a.label}`.localeCompare(b.label),
      filters: _lodash._.map(_lodash._.sortedUniq(_lodash._.uniq(_lodash._.sortBy(_lodash._.map(badgeCollections, 'label')))), x => {
        return {
          text: x,
          value: x
        };
      }),
      onFilter: (value, record) => record.label === value
    }), /*#__PURE__*/_react.default.createElement(_Column.default, {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: "200px",
      sorter: (a, b) => `${a.description}`.localeCompare(b.description)
    }), /*#__PURE__*/_react.default.createElement(_Column.default, {
      title: "Image",
      dataIndex: "badge",
      width: "50px",
      render: badge => /*#__PURE__*/_react.default.createElement(_popover.default, {
        style: {
          width: '100px'
        },
        content: /*#__PURE__*/_react.default.createElement("img", {
          src: badge
        })
      }, /*#__PURE__*/_react.default.createElement("img", {
        style: {
          height: '25px'
        },
        src: badge
      }))
    }), /*#__PURE__*/_react.default.createElement(_Column.default, {
      title: "Quota",
      dataIndex: "quota",
      key: "quota",
      width: "40px",
      sorter: (a, b) => a.quota - b.quota
    }), /*#__PURE__*/_react.default.createElement(_Column.default, {
      title: "Type",
      dataIndex: "type",
      key: "type",
      width: "50px",
      sorter: (a, b) => `${a.type}`.localeCompare(b.type),
      filters: _lodash._.map(_lodash._.sortedUniq(_lodash._.uniq(_lodash._.sortBy(_lodash._.map(badgeCollections, 'type')))), x => {
        return {
          text: x,
          value: x
        };
      }),
      onFilter: (value, record) => record.type === value
    }), /*#__PURE__*/_react.default.createElement(_Column.default, {
      title: "Sequence",
      dataIndex: "sequence",
      key: "sequence",
      width: "40px",
      sorter: (a, b) => a.sequence - b.sequence
    }), /*#__PURE__*/_react.default.createElement(_Column.default, {
      title: "Badge Collection Group",
      dataIndex: "badgeCollectionGroupLabel",
      key: "badgeCollectionGroupLabel",
      width: "100px",
      sorter: (a, b) => `${a.badgeCollectionGroupLabel}`.localeCompare(b.badgeCollectionGroupLabel),
      filters: _lodash._.map(_lodash._.sortedUniq(_lodash._.uniq(_lodash._.sortBy(_lodash._.map(badgeCollections, 'badgeCollectionGroupLabel')))), x => {
        return {
          text: x,
          value: x
        };
      }),
      onFilter: (value, record) => record.badgeCollectionGroupLabel === value
    }), /*#__PURE__*/_react.default.createElement(_Column.default, {
      title: "Create Date",
      width: "100px",
      dataIndex: "createDate",
      key: "createDate",
      render: _Util.renderDateWithTime,
      sorter: (a, b) => (0, _moment.default)(a.createDate).unix() - (0, _moment.default)(b.createDate).unix()
    }), /*#__PURE__*/_react.default.createElement(_Column.default, {
      title: "Delete Date",
      width: "100px",
      dataIndex: "deleteDate",
      key: "deleteDate",
      render: _Util.renderDateWithTime,
      sorter: (a, b) => (0, _moment.default)(a.deleteDate).unix() - (0, _moment.default)(b.deleteDate).unix()
    }), /*#__PURE__*/_react.default.createElement(_Column.default, {
      title: "Actions",
      render: this.renderActions
    }))));
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  badgeCollections: selectors.getBadgeCollections,
  status: selectors.loadBadgesStatus,
  studyId: selectors.getRequestedStudyId,
  newOrEdit: selectors.getUrlRouteNewOrEdit,
  requestedBadgeTab: selectors.getRequestedBadgeTab,
  id: selectors.getUrlNewOrEditId
});

const mapDispatchToProps = dispatch => {
  return {
    getBadgeCollections: () => dispatch(_badges.getBadgeCollectionsAsync.request()),
    deleteBadgeCollection: badgeCollectionId => dispatch(_badges.deleteBadgeCollectionAsync.request(badgeCollectionId)),
    undeleteBadgeCollection: badgeCollectionId => dispatch(_badges.undeleteBadgeCollectionAsync.request(badgeCollectionId))
  };
};

var _default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BadgeCollections));

exports.default = _default;